import { createBrowserRouter, redirect } from 'react-router';
import { routePaths } from '@/app/route-paths';
import { AppShell } from '@/routes/app-shell';
import { NotFoundRoute } from '@/routes/not-found-route';
import { RequireAuth } from '@/routes/require-auth';
import { RouteError } from '@/routes/route-error';

export const router = createBrowserRouter([
  {
    path: routePaths.login,
    lazy: async () => ({
      Component: (await import('@/routes/login/login-route')).LoginRoute,
    }),
    ErrorBoundary: RouteError,
  },
  {
    path: routePaths.phone,
    lazy: async () => ({
      Component: (await import('@/routes/phone/phone-route')).PhoneRoute,
    }),
    ErrorBoundary: RouteError,
  },
  {
    path: routePaths.register,
    lazy: async () => ({
      Component: (await import('@/routes/register/register-route')).RegisterRoute,
    }),
    ErrorBoundary: RouteError,
  },
  {
    path: routePaths.terms,
    lazy: async () => ({
      Component: (await import('@/routes/legal/terms-route')).TermsRoute,
    }),
    ErrorBoundary: RouteError,
  },
  {
    path: routePaths.privacy,
    lazy: async () => ({
      Component: (await import('@/routes/legal/privacy-route')).PrivacyRoute,
    }),
    ErrorBoundary: RouteError,
  },
  {
    Component: RequireAuth,
    ErrorBoundary: RouteError,
    children: [
      {
        path: '/',
        Component: AppShell,
        children: [
          { index: true, loader: () => redirect(routePaths.dashboard) },
          {
            path: 'dashboard',
            lazy: async () => ({
              Component: (await import('@/routes/dashboard/dashboard-route')).DashboardRoute,
            }),
          },
        ],
      },
    ],
  },
  { path: '*', Component: NotFoundRoute },
]);
